import React from "react";
import { useProductData } from "@/zustand/productStore";

const ProductSelectorButton = ({ additionalClasses = "", ...props }) => {
  const { show_product_picker_v2, show_bundle_design, subscription } = useProductData() || {};
  // If subscription is enabled, always use the V2 class
  const baseClasses = show_bundle_design
    ? "productPackages__button"
    : subscription?.subscription_enable || show_product_picker_v2
      ? "productPackages_v2__button"
      : "productPackages__button";
  const combinedClasses = `${baseClasses} ${additionalClasses}`.trim();

  return <button data-testid="product-selector" className={combinedClasses} type="button" {...props} />;
};

export default ProductSelectorButton;
